export function nameOfDevice(device) {
    if (device == null) {
        return { title: '', subtitle: '' };
    }
    return {
        title: device.individual_device_name?.trim() !== ''
            ? device.individual_device_name ?? device.name ?? ''
            : device.name ?? '',
        subtitle: device.device_type?.name ?? '',
    };
}
